export function scrollToElement(el, options = { behavior: 'smooth' }) {
    el?.scrollIntoView(options);
}
